
$(function(){    
    $(".select--wrapper--title").on("click", function() {

        var index = $(this).index(".select--wrapper--title");

        if ($(".select--wrapper.open").length >= 1) {
            
            if ($(this).parents(".select--wrapper").hasClass("open")) {
                
                $(".select--wrapper.open").removeClass("open");

            } else {
                //Close other filter boxes if open
                $(".select--wrapper.open").removeClass("open");
                $(".select--wrapper").eq(index).addClass("open");   
            }

        } else {
            $(".select--wrapper").eq(index).addClass("open");        
        }            
    })
});